/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import styled from "styled-components";

const incrementByConst = (i) => {
    let last = -3.5;
    for (let j = 0; j < i; j++) {
        last += -3.5;
    }
    return last + 2.35;
}

const CallMenu = ({ menu = [] }) => {
	const [isToggle, setIsToggle] = React.useState(false);
    if (!menu.length) return null;
	return (
		<CircularMenu
			id="circular-menu"
			className={`circular-menu is-active ${isToggle ? "active" : ""}`}
			active={isToggle}
            counts={menu.length}
		>
			<FloatBtn className="floating-btn" onClick={() => setIsToggle(!isToggle)}>
				<i aria-hidden="true" className="fas fa-bars" />
				<i aria-hidden="true" className="fas fa-times" />
			</FloatBtn>
			<div className="items-wrapper d-none">
				{menu.map((item, index) => (
					<MenuItem
						href="#"
						className="menu-item"
						key={`menu-item-${index}`}
						onClick={() => {
                            setIsToggle(false);
                            item?.onClick?.();
                        }}
                        index={index}
					>
						<i aria-hidden="true" className={`fas fa-${item.icon}`} />
						<span className="item-label">{item.name}</span>
					</MenuItem>
				))}
			</div>
		</CircularMenu>
	);
};

export default CallMenu;

const FloatBtn = styled.a`
	background-color: #37514b !important;
`;

const CircularMenu = styled.div`
	&::after {
		background-color: #37514b !important;
		${({ active, counts }) =>
			active &&
			`
            border-radius: 0.1rem !important;
            width: 5.5rem !important;
            height: ${(3.35/3 * counts) + 1}rem !important;
        `}
	}

	&.active .items-wrapper {   
        display: block !important;
	}
    top: calc(100% - 4.5rem) !important;
`;

const MenuItem = styled.a`
	& > i {
		margin-right: 10px;
	}
	font-weight: 600;
    min-width: 7.5rem !important;
	width: 13rem !important;
	height: 3rem !important;
	border-radius: 0.1rem !important;
	padding: 0 1rem !important;
    transform: translate3d(-4rem, ${({ index }) => incrementByConst(index) }rem, 0) !important;
    text-align: left !important;
`;
